import { useNavigate } from "react-router-dom";
import { FieldConfig } from "../components/Validations";
import { ClientService } from "../services/ClientService";
import Toast from "./Toast";
import Routes from "./Routes";
import { ClientDTO } from "../models/Client/ClientDTO";
import { EquipmentDTO } from "../models/Equipment/EquipmentDTO";

export type SelectItemsProps = {
    label: string;
    value: string;
};
class MaintenancePlanUtilitiesClass {

    protected clientService = new ClientService();

    public getLocationTypeList(): SelectItemsProps[] {
        return [
            { label: "Presencial", value: "Presencial" },
            { label: "Remoto", value: "Remoto" },
        ];
    }

    public getPeriodicityTypeList(intl: any): SelectItemsProps[] {
        return [
            { value: "Monthly", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityTypeOptions.Monthly" }) },
            { value: "Weekly", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityTypeOptions.Weekly" }) },
        ];
    }

    public getPeriodicityRecurrenceList(): SelectItemsProps[] {
        return [
            { value: "1", label: "1" },
            { value: "2", label: "2" },
            { value: "3", label: "3" },
            { value: "4", label: "4" },
            { value: "5", label: "5" },
            { value: "6", label: "6" },
            { value: "7", label: "7" },
            { value: "8", label: "8" },
            { value: "9", label: "9" },
            { value: "10", label: "10" },
            { value: "11", label: "11" },
            { value: "12", label: "12" },
        ];
    }

    public getPeriodicityWeekNumberList(intl: any): SelectItemsProps[] {
        return [
            { value: "First", label: "1ª" },
            { value: "Second", label: "2ª" },
            { value: "Third", label: "3ª" },
            { value: "Fourth", label: "4ª" },
            { value: "Last", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityWeekNumberOptions.Last" }) },
        ];
    }

    public getPeriodicityDayOfWeekList(intl: any): SelectItemsProps[] {
        return [
            { value: "Monday", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityDayOfWeekOptions.Monday" }) },
            { value: "Tuesday", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityDayOfWeekOptions.Tuesday" }) },
            { value: "Wednesday", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityDayOfWeekOptions.Wednesday" }) },
            { value: "Thursday", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityDayOfWeekOptions.Thursday" }) },
            { value: "Friday", label: intl.formatMessage({ id: "Screens.MaintenancePlans.Create.PeriodicityDayOfWeekOptions.Friday" }) },
        ];
    }

    public getWeeklyPeriodicityRecurrenceList(): SelectItemsProps[] {
        return [
            { value: "1", label: "1" },
            { value: "2", label: "2" },
            { value: "3", label: "3" },
            { value: "4", label: "4" },
        ];
    }

    public getValidationFields(periodicityType: string | null): FieldConfig[] {
        if (periodicityType === "Monthly") {
            return [
                ["clientErpId", "string", "Screens.MaintenancePlans.Create.Validation.ClientErpIdRequired"],
                ["applicantEmail", "string", "Screens.MaintenancePlans.Create.Validation.ApplicantEmailRequired"],
                ["name", "string", "Screens.MaintenancePlans.Create.Validation.NameRequired"],
                ["startDate", "date", "Screens.MaintenancePlans.Create.Validation.StartDateRequired"],
                ["periodicityType", "string", "Screens.MaintenancePlans.Create.Validation.PeriodicityTypeRequired"],
                ["periodicityRecurrence", "number", "Screens.MaintenancePlans.Create.Validation.PeriodicityRecurrenceRequired"],
                ["periodicityWeekNumber", "string", "Screens.MaintenancePlans.Create.Validation.PeriodicityWeekNumberRequired"],
                ["periodicityDayOfWeek", "string", "Screens.MaintenancePlans.Create.Validation.PeriodicityDayOfWeekRequired"],
                ["locationType", "string", "Screens.MaintenancePlans.Create.Validation.LocationTypeRequired"],
                ["notes", "string", "Screens.MaintenancePlans.Create.Validation.NotesRequired"],
            ];
        }
        return [
            ["clientErpId", "string", "Screens.MaintenancePlans.Create.Validation.ClientErpIdRequired"],
            ["applicantEmail", "string", "Screens.MaintenancePlans.Create.Validation.ApplicantEmailRequired"],
            ["name", "string", "Screens.MaintenancePlans.Create.Validation.NameRequired"],
            ["startDate", "date", "Screens.MaintenancePlans.Create.Validation.StartDateRequired"],
            ["periodicityType", "string", "Screens.MaintenancePlans.Create.Validation.PeriodicityTypeRequired"],
            ["periodicityRecurrence", "number", "Screens.MaintenancePlans.Create.Validation.PeriodicityRecurrenceRequired"],
            ["periodicityDayOfWeek", "string", "Screens.MaintenancePlans.Create.Validation.PeriodicityDayOfWeekRequired"],
            ["locationType", "string", "Screens.MaintenancePlans.Create.Validation.LocationTypeRequired"],
            ["notes", "string", "Screens.MaintenancePlans.Create.Validation.NotesRequired"],
        ];
    }

    public GetClientApplicants = async (clientErpId: string | null | undefined): Promise<SelectItemsProps[]> => {
        const list: SelectItemsProps[] = [];
        if (!clientErpId) {
            return list;
        }

        var response = await this.clientService.GetClientApplicants(clientErpId);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return [];
        }

        response.obj.forEach((element: any) => {
            var item: SelectItemsProps = {
                value: element.applicantEmail,
                label: `${element.applicantEmail} - ${element.applicantName}`,
            };
            list.push(item);
        });

        return list;
    };

}
export const MaintenancePlanUtilities = new MaintenancePlanUtilitiesClass();


export const useNavigateToMaintenancePlanCreate = () => {
    const navigate = useNavigate();

    return (clientErpId?: string | null | undefined, clientName?: string | null | undefined, client?: ClientDTO | null, equipment?: EquipmentDTO | null) => {
        navigate(Routes.maintenancePlans.create, { state: { clientErpId, clientName, client, equipment } }); // state tem de ser usado, pq é uma prop da interface NavigateOptions
    };
};